export default __webpack_public_path__ + "static/media/vkpic9.c1665e7f.png";